module.exports = __webpack_public_path__ + "img/empty-detail.4b5584cb.svg";